<div class="modal-header">

    <p class="modal-title"><strong>Intern Exit Upload</strong></p>

      <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>

<div class="modal-body" >

    <div class="col">
        <img class="down_img cursor-pointer" src="design/images/download.png" (click)="DownloadFile()" style="padding-top: 5px"
            ngbTooltip="Download template">

        <!-- <button  type="button" (click)="DownloadFile()" class="btn btn-secondary float-end">Download
        Template</button> -->
    </div>

    <div style="padding-top: 70px;padding-bottom: 60px;">


      <div class="col-md-12 input-group mb-7">

        <div class="col">
        </div>
        <div class="row">
          <label>Upload file</label>
        </div>
        <div class="col">
        </div>

      </div>
      <div class="input-group mb-3">
        <div class="col"></div>


        <input #fileControl name="fileName" type="file"
               (change)="fileSelected($event.target.files)" #fileName style="display: none;">

        <input #fileField type="text" class="form-control form-control-sm readonly-date" readonly
               [value]="selectedFileName"
               required />

        <div class="input-group-append">
          <button type="button" (click)="browseFile()"
                  class="btn-outline-primary">
            Browse
          </button>
        </div>
        <div class="input-group-append">
          <button type="button" (click)="uploadDoc()"
                  class="btn-outline-primary">
            Upload
          </button>

        </div>

        <div class="col"></div>




      </div>
      </div>
    </div>
